module.exports = __webpack_public_path__ + "images/rolodex_spinner.gif";